import React from 'react';
import { Disclosure } from '@headlessui/react';
import { ChevronUpIcon } from '@heroicons/react/24/outline';

export default function FAQ() {
  const faqCategories = [
    {
      title: "Products & Services",
      questions: [
        {
          question: "What types of apparel do you offer for customization?",
          answer: "We specialize in hoodies, t-shirts, and hats, offering a variety of garment styles to suit your needs."
        },
        {
          question: "What brands or types of clothing do you typically work with?",
          answer: "We work with many American apparel brands, carefully selected based on years of testing to ensure the highest quality for our customers."
        },
        {
          question: "Can you assist with logo design and creation?",
          answer: "Absolutely! We can work with you to ensure your artwork is ready for customization. If you need further assistance, we also offer logo design and creation services."
        }
      ]
    },
    {
      title: "Ordering & Pricing",
      questions: [
        {
          question: "Do you have a minimum order quantity requirement?",
          answer: "No, we have no minimum order requirement. We even offer free shipping directly to your customers on every order."
        },
        {
          question: "What are your pricing and fee structures?",
          answer: "Our pricing is straightforward – we don't have any fees at all, and we provide free shipping on all orders."
        },
        {
          question: "What payment methods do you accept?",
          answer: "We accept all common payment methods, including credit/debit cards, cash, Venmo, and PayPal. Please note that we do not accept checks."
        }
      ]
    },
    {
      title: "Process & Timeline",
      questions: [
        {
          question: "How does the customization process work?",
          answer: "We work with whatever artwork you can provide. After reviewing your artwork, we'll ensure it meets our printing standards. You'll receive proofs of the final work for approval, and once approved, we'll proceed with production, offering a quick turnaround time."
        },
        {
          question: "Can you accommodate rush orders?",
          answer: "Yes, we offer a quick turnaround time. Just let us know if you're on a deadline, and we'll do our best to meet your needs."
        },
        {
          question: "How long does it take to receive a quote for a custom order?",
          answer: "We provide same-day quotes for most requests, ensuring a quick and efficient process for our customers."
        }
      ]
    },
    {
      title: "Shipping & Support",
      questions: [
        {
          question: "Do you offer international shipping?",
          answer: "Yes, we offer worldwide shipping, and it's free!"
        },
        {
          question: "How can I track the status of my order?",
          answer: "Tracking numbers are automatically sent out when your apparel ships. Additionally, you'll always have a personal contact available to answer any questions you may have."
        },
        {
          question: "What is your return policy?",
          answer: "We have specific scenarios where we can process returns. Please consult with us for further details."
        }
      ]
    }
  ];

  return (
    <div className="bg-gray-900 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-extrabold text-cyan-500 sm:text-4xl">
            Frequently Asked Questions
          </h2>
          <p className="mt-4 text-xl text-gray-300">
            Everything you need to know about our services
          </p>
        </div>

        <div className="space-y-8">
          {faqCategories.map((category, index) => (
            <div key={category.title} className={`bg-gray-800 rounded-lg p-6 ${index % 2 === 0 ? 'ring-1 ring-cyan-500/20' : 'ring-1 ring-magenta-500/20'}`}>
              <h3 className={`text-xl font-bold mb-4 ${index % 2 === 0 ? 'text-cyan-500' : 'text-magenta-500'}`}>
                {category.title}
              </h3>
              <div className="space-y-4">
                {category.questions.map((item) => (
                  <Disclosure key={item.question}>
                    {({ open }) => (
                      <>
                        <Disclosure.Button className="flex w-full justify-between rounded-lg bg-gray-900 px-4 py-3 text-left text-sm font-medium text-white hover:bg-gray-700 focus:outline-none focus-visible:ring focus-visible:ring-cyan-500">
                          <span>{item.question}</span>
                          <ChevronUpIcon
                            className={`${
                              open ? 'rotate-180 transform' : ''
                            } h-5 w-5 ${index % 2 === 0 ? 'text-cyan-500' : 'text-magenta-500'}`}
                          />
                        </Disclosure.Button>
                        <Disclosure.Panel className="px-4 pt-4 pb-2 text-sm text-gray-300">
                          {item.answer}
                        </Disclosure.Panel>
                      </>
                    )}
                  </Disclosure>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}